import React from 'react';

import Breadcrumb from './global/Breadcrumb';
import Fieldset from './global/Fieldset';

import H1 from '../typography/H1';
import Button from './global/Button';

import SuccessSVG from '../icons/SuccessSVG';
import InvalidSVG from '../icons/InvalidSVG';

function Response(props) {
  return (
    <div>
      <div className="flex-shrink px-15 md:px-30 lg:px-45 mx-auto my-5 md:my-0 max-w-w-7xl w-full">
        <Breadcrumb breadcrumbs={props.breadCrumb} />
        <H1>{props.header}</H1>
      </div>
      <div className="flex-auto border-t-1 border-light-grey">
        <section className="pb-50 px-15 md:pb-60 md:px-30 lg:px-0 max-w-w-3xl mx-auto text-center">
          <Fieldset>
            <div className="px-5 md:px-0 mb-30 md:mb-40 w-auto large-12 columns">
              <div className="flex justify-center my-50 md:mt-100">
                {props.isApproved ? <SuccessSVG fill="#008040" height="70" width="70" viewbox="0 0 70 70" /> : <InvalidSVG fill="#d42b47" height="70" width="70" viewbox="0 0 70 70" />}
              </div>
              {props.children}
            </div>
          </Fieldset>

          <Fieldset custom classes="pt-30 md:pt-40 flex flex-col">
            <div className="w-auto m-0 p-0 flex flex-row justify-center">
              <Button value={props.buttonValue} type="button" name={props.buttonValue} classes="" buttonType="tertiary" onclick={props.buttonOnClick}>
                Back
              </Button>
              {props.isPostPaid && (
                <Button value="Print" type="button" name="print" classes="m-0 mb-15 md:mb-0 md:ml-20" buttonType="primary" onclick="window.print();">
                  Print
                </Button>
              )}
            </div>
          </Fieldset>
        </section>
      </div>
    </div>
  );
}
export default Response;
